module.exports = __webpack_public_path__ + "img/array2.9cfdcee5.png";